import React from 'react';

import classNames from 'classnames';

import { EmployeeCard } from '@entities/employee/ui/employeeCard';
import { useGetTeam } from '@entities/myTeam/lib/hooks';
import { useMyTeamContext } from '@widgets/MyTeam/model/context';
import { EmployeeActions } from '@widgets/MyTeam/ui/EmployeeActions/EmployeeActions';

import cls from './EmployeesList.module.css';
import { useEmployeesList } from '../../lib/hooks/useEmployeesList';
import { AddEmployee } from '../AddEmployee/AddEmployee';

interface EmployersListProps {
    classes?: string;
    deletingEmployee: boolean;
}

export const EmployeesList = ({ classes, deletingEmployee }: EmployersListProps) => {
    const { employees } = useEmployeesList();
    const { data } = useGetTeam();
    const { isCanUseTasks, isCanManageEmployees, currentEmployeeId } = data || {};
    const { currentClickedId } = useMyTeamContext();

    return (
        <ul className={classNames(cls.EmployersList, [classes])}>
            <li>
                <AddEmployee />
            </li>
            {employees.map((employee) => (
                <li key={employee.id}>
                    <EmployeeCard
                        employeeActionsComponent={
                            <EmployeeActions
                                employeeId={employee.id}
                                isCanUseTasks={isCanUseTasks}
                                isCanManageEmployees={isCanManageEmployees}
                                isOwner={employee.isOwner}
                                currentEmployeeId={currentEmployeeId}
                            />
                        }
                        deletingEmployee={deletingEmployee}
                        currentClickedId={currentClickedId}
                        employee={employee}
                        currentEmployeeId={currentEmployeeId}
                    />
                </li>
            ))}
        </ul>
    );
};
